import type { BRCodeStatic } from './generateBRCodeStatic.ts';
import { generateBRCodeStatic } from './generateBRCodeStatic.ts';
import { addEventListener } from './openPixState.tsx';
import pkg from '../../package.json';
import { config } from '../config.tsx';
import { log } from '../log/OpenPixLogger.tsx';

export type BRCodeOutput = {
  error: string | null;
  brCode: string | null;
};

export type IOpenPixApi = {
  generateStatic: (options: BRCodeStatic) => BRCodeOutput;
  status: () => void;
  addEventListener: () => void;
};

const generateStatic = (options: BRCodeStatic): BRCodeOutput => {
  if (!options?.key) {
    return {
      error: 'Missing key (pix key) inside options',
      brCode: null,
    };
  }

  return { brCode: generateBRCodeStatic(options), error: null };
};

const status = () => {
  // TODO - get server version

  log('SDK', {
    version: pkg.version,
    environment: config.OPENPIX_ENV,
    timestamp: config.BUILD_TIMESTAMP,
    commit: config.COMMIT_SHA,
    IS_RSPACK: config.IS_RSPACK,
  });
};

export const attachOpenPixApi = (datalayer) => {
  const api = {
    generateStatic,
    status,
    addEventListener,
  };

  Object.keys(api).map((k) => {
    datalayer[k] = api[k];
  });

  return datalayer;
};
